(() => {
  if (window.zsCollectionQuickAddReady) return;
  window.zsCollectionQuickAddReady = true;
  const root = window.Shopify?.routes?.root || '/';
  const getCart = async () => {
    const r = await fetch(`${root}cart.js`, {credentials:'same-origin',headers:{Accept:'application/json'}});
    if (!r.ok) throw Error('Cart read failed');
    return r.json();
  };
  const buttons = () => document.querySelectorAll('[data-zs-collection-add], [data-zs-silent-add]');
  function sync(cart) {
    const variants = new Set((cart.items || []).map(item => String(item.variant_id)));
    buttons().forEach(button => {
      if (button.dataset.soldOut === 'true' || button.closest('.card-wrapper')?.querySelector('.badge')?.textContent?.trim() === 'Sold out') return;
      const added = variants.has(String(button.dataset.variantId));
      button.classList.toggle('is-added', added);
      button.disabled = added;
      button.setAttribute('aria-disabled', String(added));
      const label = button.querySelector('[data-zs-add-label]') || button.querySelector('span');
      if (label) label.textContent = added ? (button.dataset.addedLabel || '✓ Added') : (button.dataset.addLabel || 'Add');
    });
    const icon = document.getElementById('cart-icon-bubble');
    if (icon) {
      let bubble = icon.querySelector('.cart-count-bubble');
      if (cart.item_count && !bubble) {
        bubble = document.createElement('div');
        bubble.className = 'cart-count-bubble';
        bubble.innerHTML = '<span aria-hidden="true"></span><span class="visually-hidden"></span>';
        icon.appendChild(bubble);
      }
      if (bubble && !cart.item_count) bubble.remove();
      else if (bubble) {
        const number = bubble.querySelector('[aria-hidden="true"]');
        if (number) number.textContent = cart.item_count < 100 ? String(cart.item_count) : '';
        const spoken = bubble.querySelector('.visually-hidden');
        if (spoken) spoken.textContent = `${cart.item_count} items in cart`;
      }
    }
  }
  let refreshToken = 0;
  async function refresh() {
    const token = ++refreshToken;
    const cart = await getCart();
    if (token === refreshToken) sync(cart);
    return cart;
  }
  // Refresh drawer content in place, preserving its closed/open state.
  async function refreshDrawer() {
    const drawer = document.querySelector('cart-drawer');
    const oldInner = drawer?.querySelector('#CartDrawer .drawer__inner');
    if (!oldInner) return;
    const url = new URL(root, location.origin);
    url.searchParams.set('sections','cart-drawer');
    const response = await fetch(url, {credentials:'same-origin'});
    if (!response.ok) return;
    const html = (await response.json())['cart-drawer'];
    if (!html) return;
    const fresh = new DOMParser().parseFromString(html,'text/html').querySelector('cart-drawer');
    const inner = fresh?.querySelector('#CartDrawer .drawer__inner');
    if (!inner) return;
    oldInner.innerHTML = inner.innerHTML;
    drawer.classList.toggle('is-empty', fresh.classList.contains('is-empty'));
    oldInner.classList.toggle('is-empty', inner.classList.contains('is-empty'));
  }
  // Capture only single-variant collection forms. Variant-option modals retain Trade behavior.
  document.addEventListener('submit', async event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.matches('[data-zs-collection-form]')) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    const button = form.querySelector('[data-zs-collection-add]');
    if (!button || button.disabled || button.dataset.loading === 'true' || button.dataset.soldOut === 'true') return;
    const variant = form.querySelector('[name="id"]')?.value;
    if (!variant) return;
    button.dataset.loading = 'true';
    button.setAttribute('aria-busy','true');
    try {
      const response = await fetch(`${root}cart/add.js`, {
        method:'POST',credentials:'same-origin',
        headers:{'Content-Type':'application/json',Accept:'application/json'},
        body:JSON.stringify({items:[{id:Number(variant),quantity:1}]})
      });
      if (!response.ok) throw Error('Add failed');
      const cart = await refresh();
      document.dispatchEvent(new CustomEvent('zs:cart-updated',{detail:{cart}}));
      // Existing product-page subscribers and Trade cart handlers can use the same update.
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate,{source:'zs-collection-silent',cartData:cart,productVariantId:variant});
      }
      refreshDrawer().catch(console.warn);
    } catch (error) {
      console.warn('Silent collection add failed',error);
      const label = button.querySelector('[data-zs-add-label]');
      if (label) label.textContent = button.dataset.addLabel || 'Add';
      setTimeout(() => refresh().catch(console.warn), 1500);
    } finally {
      button.dataset.loading = 'false';
      button.removeAttribute('aria-busy');
    }
  }, true);
  document.addEventListener('zs:cart-updated', event => {
    if (event.detail?.cart?.items) sync(event.detail.cart);
    else refresh().catch(console.warn);
  });
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, event => {
      if (event?.cartData?.items) sync(event.cartData);
      else refresh().catch(console.warn);
    });
  }
  document.addEventListener('shopify:section:load', () => refresh().catch(console.warn));
  document.addEventListener('visibilitychange', () => {
    if (!document.hidden) refresh().catch(console.warn);
  });
  refresh().catch(console.warn);
})();
